import { useNewbuildingListingUrl } from '../../../hooks';
import { IPromoPopup } from '../../../types/promosPage';

export const useNewbuildingCountLink = (promoPopup: IPromoPopup | null): string | undefined => {
  const newbuildingCountLink = useNewbuildingListingUrl(promoPopup?.newbuildingIds || []);

  if (promoPopup?.isNewbuildingCountTextLinkable) {
    return newbuildingCountLink;
  }

  return undefined;
};
